import React from 'react';

import PlaybookStepPage from './PlaybookStepPage';

interface Props {}

const TheSearch: React.FC<Props> = () => {
  return <PlaybookStepPage title="The Search" activeStep={2} />;
};

export default TheSearch;
